module.exports = __webpack_public_path__ + "img/gld_gbt65_2000.prt.1449636c.jpg";